export default __webpack_public_path__ + "static/media/sixCut.f6b4a0d9.gif";